import { getStoreBuilder, BareActionContext } from 'vuex-typex'
import { RootState } from "@/types"
import { PortfolioState, PortfolioStore, Portfolio } from "./types"
import firebase from 'firebase'

// const delay = (duration: number) => new Promise((c, e) => setTimeout(c, duration))

const b = getStoreBuilder<RootState>().module('portfolio', { items: [] })
const stateGetter = b.state()



export const portfolioStore: PortfolioStore = {
  // state
  get state() { return stateGetter() },

  // Load portfolio
  loadPortfolio: b.dispatch(loadPortfolio)


}


async function loadPortfolio(
  context: BareActionContext<PortfolioState, RootState>) {
  try {
    const portfolioCollection = await firebase.firestore().collection('portfolio')
    const portfolio = await portfolioCollection.get()
    let portfolioList: Portfolio[] = portfolio.docs.map(doc => (doc.data() as Portfolio));
    context.state.items = portfolioList
  } catch (error) {
    throw new Error(error);
  }

}
